module.exports = __webpack_public_path__ + "static/media/spock.742059d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spock.png
// module id = 510
// module chunks = 0